// 菜单相关模块
import axios from 'axios'
const state = {
    menuList: [
        {
            index: '2',
            title: '小区管理',
            icon: '3',
            children: [
                {
                    index: '2-1',
                    title: '我的小区',
                    name: 'myServiceHa',
                    params: {}
                }
            ],
        },
/*        {
            index: '6',
            title: '物业缴费',
            icon: '1',
            children: [
                {
                    index: '6-0',
                    title: '开通物业缴费',
                    name: 'openWyfee',
                    params: {},
                    //condition: 'isAdmin',
                },
                {
                    index: '6-1',
                    title: '房屋信息管理',
                    name: 'houseList',
                    params: {},
                    condition: 'isAdmin',
                },
                {
                    index: '6-2',
                    title: '物业费缴费情况统计',
                    name: 'orderList',
                    params: {},
                    condition: 'isAdmin',
                },
                {
                    index: '6-3',
                    title: '物业费欠缴明细统计',
                    name: 'arrearsList',
                    params: {},
                    condition: 'isAdmin',
                }
            ],
        },
        {
            index: '7',
            title: '物业报修',
            icon: '4',
            children: [
                {
                    index: '7-1',
                    title: '物业报修列表',
                    name: 'repairList',
                    params: {},
                    condition: 'isAdmin',
                },
            ],
        },
*/        {
            index: '3',
            title: '房产中介',
            icon: '6',
            children: [
                {
                    index: '3-2',
                    title: '房源发布',
                    name: 'release',
                    params: {saleOrLease: 'forsale'}
                },
                {
                    index: '3-1',
                    title: '我的房源',
                    name: 'houseManage',
                    params: {}
                },
                {
                    index: '2-2',
                    title: '全网房源',
                    name: 'analysis',
                    params: {saleOrLease: 'forsale'}
                },
                {
                    index: '2-3',
                    title: '宣传海报',
                    name: 'posterManage',
                    params: {}
                }
            ],
        },
        {
            index: '5',
            title: '公众号运营',
            icon: '2',
            children: [
                {
                    index: '5-1',
                    title: '公众号管理',
                    name: 'wechatAccount',
                    params: {}
                },
                {
                    index: '5-2',
                    title: '自定义菜单',
                    name: 'selfMenu',
                    params: {},
                    condition: 'showSelfMenu'
                },
                {
                    index: '5-3',
                    title: '消息群发',
                    name: 'messaging',
                    params: {},
                    condition: 'showMessage'
                }
            ],
        },
        {
            index: '4',
            title: '账户管理',
            icon: '5',
            privilegeNotShow: true, //权限设置时不显示该菜单
            children: [
                {
                    index: '4-1',
                    title: '公司基本信息',
                    name: 'comInfo',
                    params: {},
                    condition: 'isAdmin',
                },
                {
                    index: '4-2',
                    title: '个人基本资料',
                    name: 'myInfo',
                    params: {},
                    forever: true, //永久显示， 不必分配权限
                },
                {
                    index: '4-3',
                    title: '账号绑定',
                    name: 'accountBinding',
                    params: {},
                    forever: true, //永久显示， 不必分配权限
                },
                {
                    index: '4-4',
                    title: '员工权限管理',
                    name: 'staffList',
                    params: {},
                    condition: 'isAdmin',
                }
            ],
        }
    ],
    // 活动菜单
    activeMenu: '',
    // 用户菜单
    userMenu: JSON.parse(window.localStorage.getItem('userMenu')) || [],
}
const getters = {
    // 获取菜单列表信息
    menuList: (state) => state.menuList,
    // 获取active menu信息
    activeMenu: (state) => state.activeMenu,
    // 获取用户权限菜单
    userMenu: (state) => state.userMenu,
}
const mutations = {
    // 获取活动菜单信息
    updateActiveMenu: (state, activeMenu) => {
        state.activeMenu = activeMenu;
    },
    // 更新用户权限信息
    updateUserMenu(state, options) {
        state.userMenu = options;
        window.localStorage.setItem('userMenu', JSON.stringify(options));
    }
}
const actions = {
    setActiveMenu: ({commit, state}, options) => {
        let allMenu = [];
        for(let menu of state.menuList) {
            if(menu.children) {
                allMenu.push(...menu.children);
            }
        }
        // 当前链接是否是菜单
        let [curMenu] = allMenu.filter(menu => menu.name == options);
        if(!curMenu && options != 'index') return;
        let menuIndex = 'index';
        if (curMenu) {
            menuIndex = curMenu.index;
        }
        commit('updateActiveMenu', menuIndex);
    },
    setUserMenu: ({commit}, options) => {
        commit('updateUserMenu', options);
    },
    // 异步获取用户菜单权限信息
    async updateUserMenu({commit, getters}) {
        const params = {
            cityCode: getters.getFinalCity('code'),
            uid: getters.getUserInfo('userId')
        }
        await axios.get("/api/company/menu", {params}).then(({status, data}) => {
            let permissions = [];
            if (status == 200 && data.status == 200 && data.data) {
                let {permission} = data.data;
                permissions = permission ? permission.split(',') : [];
            }
            window.sessionStorage.setItem("areadyUpdateUserMenu",1);
            commit('updateUserMenu', permissions);
        })
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Menu.js